import React from "react";

import BackGround from "components/common/BackGround";
import Gnb from "components/common/Gnb";
import Footer from "components/common/Footer";
import Terms from "components/term/Terms"

export default function Term() {
    return (
        <BackGround>
            <Gnb />
            <Terms />
            <Footer />
        </BackGround>
    );
}